<div class="narrow-panel-container">
    <div class="narrow-panel-header">
        @if (!!path && path.length > 0) {
          <div class="content-title-1">
            {{ path[path.length - 1] }}
          </div>
        }
        <div>
          <button
            (click)="toggleExpanded()"
            mat-icon-button
            [attr.aria-label]="expanded ? 'Collapse' : 'Expand'"
            [matTooltip]="expanded ? 'Collapse' : 'Expand'"
          >
            <mat-icon class="action-icon">
              @if (expanded) {
                collapse_content
              } @else {
                expand_content
              }
            </mat-icon>
          </button>
          <button (click)="close()"
                  mat-icon-button
                  aria-label="close"
          >
            <mat-icon class="action-icon">close</mat-icon>
          </button>
        </div>
    </div>

    <div class="narrow-panel-section">
        @for (routeCategory of getRouteCategories(); track $index) {
          <div class="content-title-2">
            {{ routeCategory }}
          </div>
        }

      <div class="space-between">
          @if (usedRouteConfiguration) {
            <div class="content-title-3">
              {{ usedRouteConfiguration.name }}
            </div>
          }

          @if (routeLength !== null && routeLength !== undefined) {
            <div class="content-title-3">
              {{ (routeLength / 1000 || 0) | distance:configuration.useMetricSystem:true }}
            </div>
          }
        </div>
    </div>

  @if (expanded) {
    <div class="narrow-panel-divider">
    </div>

    <div class="narrow-panel-section">
        <div class="content-title-2">
            <button
                    mat-button
                    color="accent"
                    [matMenuTriggerFor]="timeFilterMenu"
            >
                <div class="time-filter-button">
                    @if (timeFromHours === 24) {
                      <span>Last 24 hours</span>
                    }
                    @if (timeFromHours === 168) {
                      <span>Last Week</span>
                    }
                    <mat-icon>
                        arrow_drop_down
                    </mat-icon>
                </div>
            </button>
            <mat-menu #timeFilterMenu="matMenu">
                <button
                        mat-menu-item
                        (click)="changeTimeFilter(24)"
                >
                    Last 24 hours
                </button>
                <button
                        mat-menu-item
                        (click)="changeTimeFilter(168)"
                >
                    Last Week
                </button>
            </mat-menu>
        </div>

        @if (!routeMetrics) {
          <div class="content-paragraph">
            <mat-spinner></mat-spinner>
          </div>
        }

        @if (configuration && routeMetrics) {
          <div class="content-paragraph">
            <div class="content-row">
              <div class="info-metric">
                <span>{{ assignmentCompleteCount }}</span>
              </div>
              <div class="info-value">
                Completed assignment@if (assignmentCompleteCount !== 1) { <span>s</span> }
              </div>
            </div>

            <div class="content-row">
              <div class="info-metric">
                <span>{{ assignmentInProgressCount }}</span>
              </div>
              <div class="info-value">
                Active assignment@if (assignmentInProgressCount !== 1) { <span>s</span> }
              </div>
            </div>

            <div class="content-row">
              <div class="info-metric">
                <span>{{ (routeMetrics.totalDistance / 1000 || 0) | distance:configuration.useMetricSystem:false }}</span>
              </div>
              <div class="info-value">
                Total&nbsp;@if (configuration.useMetricSystem) { <span>kilometers</span> } @else { <span>miles</span> } driven
              </div>
            </div>

            <div class="content-row">
              <div class="info-metric">
                <span>{{ (routeMetrics.avgDistancePerAssignment / 1000 || 0) | distance:configuration.useMetricSystem:false }}</span>
              </div>
              <div class="info-value">
                Avg @if (configuration.useMetricSystem) { <span>kilometers</span> } @else { <span>miles</span> }
                per assignment
              </div>
            </div>

            <div class="content-row">
              <div class="info-metric">
                <span>{{ (routeMetrics.avgTimePerAssignment / 3600 || 0) | number:'1.0-2' }}</span>
              </div>
              <div class="info-value">
                Avg time per assignment
              </div>
            </div>
          </div>
        }
    </div>

    <div class="narrow-panel-divider">
    </div>

    <div class="narrow-panel-section">
        <div class="space-between">
          <div class="content-title-2">
            Assignment Queue
          </div>
          <button mat-icon-button
                  color="accent"
                  [routerLink]="[]"
                  [queryParams]="getRightPanelQueryParams(DrawerType.ROUTE)"
                  [matTooltip]="'Assign the route for a vehicle'"
          >
            <mat-icon>add_circle</mat-icon>
          </button>
        </div>

        <div class="content-paragraph">
            <app-route-assignment-queue
                [routeConfigId]="filterRouteConfigId"
                [routeId]="filterRouteIds[0]"
                [timeFromHoursFilter]="24"
            ></app-route-assignment-queue>
        </div>
    </div>
  }
</div>
